export enum NoteTypeValue {
    INTERNAL = 'INTERNAL',
    FRAUD = 'FRAUD',
    TAG = 'TAG',
    PET_PARENT = 'PET_PARENT',
    MISSING_INFO = 'MISSING_INFO',
    CLAIM_SUMMARY = 'CLAIM_SUMMARY',
}
